/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Produktclass1Inputs */

const de__field_produktclass1 = /** @type {(inputs: _Field_Produktclass1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt`)
};

/**

* @param {_Field_Produktclass1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_produktclass1 = /** @type {((inputs?: _Field_Produktclass1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Produktclass1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_produktclass1(inputs)
});
export { _field_produktclass1 as "_field_produktClass" }